import { LiveButton as LiveButton$1 } from "../../../../../ui/live-button/component.js";
import { Button } from "./button.js";
import { jsx } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/buttons/live-button.tsx
/** @jsxImportSource react */
function LiveButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(LiveButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-live-button", resolveClassName(className, state)),
		...props
	});
}
//#endregion
export { LiveButton };

//# sourceMappingURL=live-button.js.map